module.exports = __webpack_public_path__ + "img/hard-manual.1ead770b.png";